<template>
  <el-dialog title="留言详情" :append-to-body="true" :visible.sync="visible" :show-close="false" width="800px" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
      class="el-dialog__close el-icon el-icon-close"></i></button>
    <el-form :model="reply" size="small">
      <el-form-item label="直播标题" label-width="120px">
        {{videoTitle}}
      </el-form-item>
      <el-form-item label="律师姓名" label-width="120px">
        {{lawyerName}}
      </el-form-item>
      <el-form-item label="内容" label-width="120px">
        {{reply.content}}
      </el-form-item>
      <el-form-item label="留言时间" label-width="120px">
        {{reply.msgTime}}
      </el-form-item>
      <div v-if="reply.replyContent===null">
        <el-form-item label="回复" label-width="120px">
          <el-input type="textarea" :rows="4" v-model="replyContent" autocomplete="off"></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="回复内容" label-width="120px">
          {{reply.replyContent}}
        </el-form-item>
        <el-form-item label="回复人" label-width="120px">
          {{reply.replyUesr}}
        </el-form-item>
        <el-form-item label="回复时间" label-width="120px">
          {{reply.replyTime}}
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" v-if="reply.replyContent===null" class="dialog-footer">
      <el-button type="primary" @click="save">回复</el-button>
    </div>
  </el-dialog>
</template>
<script>
import reply from '@/api/reply'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    values: {
      type: Number,
      required: false,
      default: null
    },
    videoTitle: {
      type: String,
      required: false,
      default: ''
    },
    lawyerName: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      replyContent: '',
      // 留言
      reply: {
        id: null,
        liveId: null,
        lawyerId: null,
        content: '',
        msgTime: '',
        replyContent: '',
        replyTime: '',
        replyUesr: '',
        status: '1',
        createBy: ''
      }
    }
  },
  methods: {
    initForm () {
      this.reply = {
      }
      if (this.$refs.reply) {
        this.$refs.reply.resetFields()
      }
    },
    cancelModal () {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit('update:visible', false)
    },
    reload () {
      if (this.values !== null) {
        // 根据liveid查找live liveTime 和附件
        reply.load({id: this.values}).then(res => {
          this.reply = res.data.data
          // this.reply.replyContent = ''
          // console.log('留言详情：')
          // console.log(res.data.data)
        })
      }
    },
    // 回复
    save () {
      let rep = {
        id: this.values,
        replyUesr: null, // 后台获取?
        replyContent: this.replyContent
      }
      reply.replyMsg(rep).then(res => {
        // console.log(res.data.data)
       this.$message.info(res.data.message)
        if (res.data.code===0){
          this.$emit('callFather')
          this.$emit('update:visible', false)
        }
      })
    }
  },
  created () {
    // console.log(this.values)
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/video/reply/Reply.vue